module.exports = __webpack_public_path__ + "static/assets/d1cc5b5ad7a9453280001cbda1f6ff5c.svg";